module.exports = __webpack_public_path__ + "fonts/Gotham-Book.d2f5e3d5.woff";